import type { ReportJobStatuses } from '@vy/types';
import { REPORT_JOB_STATUSES } from '@vy/types';
import { raiseUnreachable } from '@vy/utils';
import type { HTMLAttributes } from 'react';
import React from 'react';
import { Status } from './statuses/Status/Status';
import type { StatusType } from './statuses/Status/status-types/status-types';

type ReportJobStatusChipProps = HTMLAttributes<HTMLSpanElement> & {
  status: ReportJobStatuses;
};

export const ReportJobStatusChip: React.FC<ReportJobStatusChipProps> = ({ status, className, ...props }) => {
  return (
    <Status status={getStatusType(status)} {...props}>
      {status}
    </Status>
  );
};

function getStatusType(status: ReportJobStatuses): StatusType {
  switch (status) {
    case REPORT_JOB_STATUSES.Completed:
      return 'SUCCESS';
    case REPORT_JOB_STATUSES.Pending:
      return 'INFO';
    case REPORT_JOB_STATUSES.Failed:
      return 'ERROR';
    case REPORT_JOB_STATUSES.Cancelled:
      return 'WARNING';
    default:
      return raiseUnreachable(status);
  }
}
